import React from 'react';
import { useTranslation } from 'react-i18next';


export function About() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className="sub-container">
        <div className="txt_box">
          <span className="txt_title">{t('page.about.title')}</span>
          <ol>
            <li className="point-style">
              {t('page.about.content.1')}
            </li>
            <li className="point-style">
              {t('page.about.content.2')}
            </li>
            <li className="point-style">
              {t('page.about.content.3')}
            </li>
          </ol>
        </div> 
      </div>
    </div>
  );
}



